import { ERRORS__POP, ERRORS__PUSH, ERRORS__REMOVE } from './constants.errors';

export const showErrorModal = (message, status = 400, data) => ({
  type: ERRORS__PUSH,
  payload: { data, message, status },
});

export const popError = () => ({
  type: ERRORS__POP,
});

export const removeError = (error) => ({
  type: ERRORS__REMOVE,
  payload: error,
});
